/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Puntos_Clave_Informacion = ({item}) => {

    const {masSM} = useResponsive();

    const htmlFrom = (htmlString) => {
        const cleanHtmlString = DOMPurify.sanitize(htmlString,
            {USE_PROFILES: {html: true}});
        const html = parse(cleanHtmlString);
        return html;
    }

    return (
        <Grid2 container
               justifyContent={'flex-start'}
               alignItems={'center'}
               spacing={4}
               size={12}
               sx={{pl: masSM ? 6 : 2, ml: masSM ? 6 : 0, borderLeft: `6px solid #000`}}>

            <Grid2 container size={12}>
                <Typography
                    sx={{color: theme.palette.primary.main, fontSize: 32, fontWeight: '800'}}
                >
                    Puntos Clave
                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography sx={{fontSize: 20}}>
                    {item && item.puntosClave && htmlFrom(item?.puntosClave)}
                </Typography>
            </Grid2>


        </Grid2>
    )

}
export default Puntos_Clave_Informacion;